import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col col-xxl-8" }, [
      /*#__PURE__*/_createElementVNode("p", null, "Hier zie je een overzicht van de beschikbare optiepakketten in ons platform. Je kan een optiepakket eenvoudig bestellen via de knop \"Bestel hier\". Digital Pharma zorgt dan voor de activatie en zal indien nodig contact opnemen om verder af te stemmen. Heb je interesse in één van deze opties en wil je wat meer informatie hierover, klik dan op de knop \"Meer info\" dan nemen wij contact met jullie op om een woordje uitleg te geven. ")
    ])
  ])
], -1)
const _hoisted_2 = { class: "row mt-xxl-1" }
const _hoisted_3 = { class: "d-flex justify-content-center" }
const _hoisted_4 = { class: "col col-xxl-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Werk je met "),
    /*#__PURE__*/_createElementVNode("strong", null, "kluisjes"),
    /*#__PURE__*/_createTextVNode(" of een "),
    /*#__PURE__*/_createElementVNode("strong", null, "automaat"),
    /*#__PURE__*/_createTextVNode(", of wil je zelf als apotheker aan huis leveren bij (bepaalde) patiënten? Dan kunnen je patiënten nu makkelijk de gewenste levermethode aangeven. Je kan zelf bepalen welke levermethodes je wil aanbieden en onder welke voorwaarden (bijv. alleen voor patiënten die moeilijk te been zijn en binnen een bepaalde straal wonen). Je kan als apotheker steeds de door de patiënt gewenste levermethode aanvaarden of weigeren. ")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Met PharmaPIM is het mogelijk om bijkomende informatie over bepaalde producten op de detailpagina van je website te tonen, zoals een uitgebreide beschrijving, de samenstelling, het gebruik ervan, …"),
  /*#__PURE__*/_createElementVNode("p", null, "Je kan via het menupunt catalogus/productkeuze onder het tabblad \"producten\" op een productnaam klikken om te zien welke informatie er beschikbaar is (dit kan je ook zien als je nog niet over deze optie beschikt). Bovendien kan je hier feedback geven over de beschikbare informatie door op het icoontje met het uitroepteken te klikken. Heb je een opmerking? Laat het ons dan zeker weten!")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Indien je jouw website wil aanbieden in meerdere talen dan heb je het optiepakket meertaligheid nodig. Je hebt dan de mogelijkheid om jouw website in twee of meer van volgende talen aan te bieden: Nederlands, Frans, Duits en Engels. De inhoud van je website moet je dan uiteraard wel voorzien in de gekozen talen."),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Opgelet"),
    /*#__PURE__*/_createTextVNode(": de productcatalogus is alleen in het Nederlands en Frans voorzien. Voor Duits en Engels zal de Nederlandstalige catalogus getoond worden.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "De standaard berichten die naar de patiënt gestuurd worden bij het afhandelen van een order zijn wel in de vier talen beschikbaar.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "We kunnen je productcatalogus synchroniseren met jouw apotheeksoftware. Op dit moment is dat mogelijk voor volgende softwarepakketten: Farmad, Corilus Greenock, Pharmagest, Officinal en Pharmony. Contacteer je softwareleveranciers om na te gaan welke kosten zij eventueel aanrekenen voor deze service."),
  /*#__PURE__*/_createElementVNode("p", null, "De synchronisatie heeft volgende voordelen:"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "De productprijzen worden overgenomen uit jullie software. Zonder deze optie worden de publieksprijzen (of adviesprijzen) in jullie catalogus getoond. Deze prijzen kunnen soms licht afwijken van de prijzen in jullie software. "),
    /*#__PURE__*/_createElementVNode("li", null, "Kortingen kunnen overgenomen worden vanuit jullie software. Indien je kortingen hebt ingegeven in jouw software, dan kunnen deze overgenomen worden in de website. Opgelet. In sommige software is het niet eenvoudig om kortingen in te geven en vinden onze klanten het gemakkelijker om de korting in ons beheer in te geven. Hier moet de nodige aandacht aan besteed worden om een juiste werking te krijgen. "),
    /*#__PURE__*/_createElementVNode("li", null, "Je kan ervoor kiezen om producten die volgens jouw software op stock zijn automatisch op jouw website te tonen. ")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Als je via het orderbeheer een bevestiging stuurt naar de patiënt dat een order klaar is, dan kan je daar een betaallink bij versturen. Dit kan je voor ieder order apart beslissen."),
  /*#__PURE__*/_createElementVNode("p", null, "Op deze manier geef je de mogelijkheid aan de patiënt om op voorhand te betalen zodat je in de apotheek minder tijd moet spenderen als de patiënt het order komt afhalen."),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Handig"),
    /*#__PURE__*/_createTextVNode(": als je met kluisjes of een automaat werkt, kan je ervoor kiezen om de patiënt verplicht eerst te laten betalen via de link voordat je de code om het kluisje te openen doorgeeft.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Opmerking"),
    /*#__PURE__*/_createTextVNode(": voor deze optie heb je ook een contract nodig bij een PSP (Payment Service Provider). Op dit moment hebben we een koppeling mogelijk met volgende PSP's: Mollie en Payconiq. Wij helpen je graag verder om daar een account te openen. De kost voor de PSP's zelf worden rechtstreeks aan de apotheek aangerekend.")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "We hebben een assortiment aan gezondheid gerelateerde artikels beschikbaar in onze database die kunnen gebruikt worden om op je website te zetten. Regelmatig komen er ook artikels bij. Je kan zelf ook eigen artikels toevoegen.")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Met ORCA (Order Campaign MAnager) is het eenvoudig om griepspuiten, covid/RSV vaccin's en/of Ozempic te laten reserveren."),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Opmerking"),
    /*#__PURE__*/_createTextVNode(": Indien je gebruik wenst te maken van SMS communicatie, wordt dat volgens het standaard SMS tarief apart verrekend.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Opmerking"),
    /*#__PURE__*/_createTextVNode(": Standaard wordt een campagne voor de griepspuit geactiveerd. Wens je ORCA ook in te zetten voor het beheren van je reservaties voor covid/RSV vaccins en/of Ozempic, geef ons dan een seintje, dan activeren we dit voor jou.")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "De digitale communicatie met de patiënt om een order te bevestigen of te laten weten wat de status van zijn order is gebeurt steeds via e-mail. Het is ook mogelijk om de patiënt bijkomend via SMS op de hoogte te brengen van de status van zijn bestelling.")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Met een Multi-apotheek website is het mogelijk om verschillende vestigingen te vermelden op één website. Als de patiënt een order wil doorsturen moet hij in het bestelproces aangeven bij welke vestiging hij het order wil plaatsen.")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Ben je gegroepeerd met een aantal apotheken, maar wens je toch een aparte website per lid van de groep dan hebben we deze oplossing voor jullie. Indien gewenst is er een overkoepelende website van waaruit door kan gelinkt worden naar de individuele apotheekwebsites."),
  /*#__PURE__*/_createElementVNode("p", null, "Het is mogelijk om centraal alle websites te beheren. Op die manier moeten er bijvoorbeeld maar op één plaats kortingen ingesteld worden die automatisch overgenomen worden op alle apotheekwebsites van de groep. Verder moeten gemeenschappelijke inhoudelijke pagina's maar één keer aangemaakt worden waarna per apotheekwebsite kan gekozen worden om deze inhoud al dan niet over te nemen.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_option_pack_card = _resolveComponent("option-pack-card")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, { "container-fluid": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('optionPacks'),
        mb: 5,
        "show-refresh-button": "",
        onRefresh: this.reloadContent
      }, null, 8, ["title", "onRefresh"]),
      _createVNode(_component_AlertError2, {
        error: this.pageUI.getError()
      }, null, 8, ["error"]),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_option_pack_card, {
              title: this.productDescription('ALTERNATIVE_DELIVERY_METHODS_PACK'),
              orderMailToLink: this.orderMailToLink('ALTERNATIVE_DELIVERY_METHODS_PACK'),
              moreInfoMailToLink: this.moreInfoMailToLink('ALTERNATIVE_DELIVERY_METHODS_PACK'),
              licensePrice: "€ 75",
              licensePriceSuffix: "/jaar",
              availableFor: this.availableFor('ALTERNATIVE_DELIVERY_METHODS_PACK')
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["title", "orderMailToLink", "moreInfoMailToLink", "availableFor"]),
            _createVNode(_component_option_pack_card, {
              title: this.productDescription('PIM_FOR_WEBSITE_PACK'),
              orderMailToLink: this.orderMailToLink('PIM_FOR_WEBSITE_PACK'),
              moreInfoMailToLink: this.moreInfoMailToLink('PIM_FOR_WEBSITE_PACK'),
              licensePrice: "€ 130",
              licensePriceSuffix: "/jaar",
              availableFor: this.availableFor('PIM_FOR_WEBSITE_PACK')
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["title", "orderMailToLink", "moreInfoMailToLink", "availableFor"]),
            _createVNode(_component_option_pack_card, {
              title: this.productDescription('MULTILINGUAL'),
              orderMailToLink: this.orderMailToLink('MULTILINGUAL'),
              moreInfoMailToLink: this.moreInfoMailToLink('MULTILINGUAL'),
              setupPrice: "€ 350",
              licensePrice: "€ 135",
              licensePriceSuffix: "/jaar",
              availableFor: this.availableFor('MULTILINGUAL')
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["title", "orderMailToLink", "moreInfoMailToLink", "availableFor"]),
            _createVNode(_component_option_pack_card, {
              title: this.productDescription('PHARMACY_SW_SYNC_PACK'),
              orderMailToLink: this.orderMailToLink('PHARMACY_SW_SYNC_PACK'),
              moreInfoMailToLink: this.moreInfoMailToLink('PHARMACY_SW_SYNC_PACK'),
              setupPrice: "€ 500",
              availableFor: this.availableFor('PHARMACY_SW_SYNC_PACK')
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["title", "orderMailToLink", "moreInfoMailToLink", "availableFor"]),
            _createVNode(_component_option_pack_card, {
              title: this.productDescription('ONLINE_PAYMENT_PACK'),
              orderMailToLink: this.orderMailToLink('ONLINE_PAYMENT_PACK'),
              moreInfoMailToLink: this.moreInfoMailToLink('ONLINE_PAYMENT_PACK'),
              licensePrice: "€ 25",
              licensePriceSuffix: "/jaar",
              availableFor: this.availableFor('ONLINE_PAYMENT_PACK')
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["title", "orderMailToLink", "moreInfoMailToLink", "availableFor"]),
            _createVNode(_component_option_pack_card, {
              title: this.productDescription('PUBLISH_DP_ARTICLES'),
              orderMailToLink: this.orderMailToLink('PUBLISH_DP_ARTICLES'),
              moreInfoMailToLink: this.moreInfoMailToLink('PUBLISH_DP_ARTICLES'),
              setupPrice: "€ 150",
              licensePrice: "€ 24",
              licensePriceSuffix: "/jaar",
              availableFor: this.availableFor('PUBLISH_DP_ARTICLES')
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["title", "orderMailToLink", "moreInfoMailToLink", "availableFor"]),
            _createVNode(_component_option_pack_card, {
              title: this.productDescription('ORCA_MODULE'),
              orderMailToLink: this.orderMailToLink('ORCA_MODULE'),
              moreInfoMailToLink: this.moreInfoMailToLink('ORCA_MODULE'),
              licensePrice: "€ 0,1",
              licensePriceSuffix: " per reservatie *",
              priceInfo: "* Met een maximum van 200€/jaar. Deze prijs wordt na ieder licentiejaar berekend op het werkelijk verbruik van het voorbije licentiejaar.",
              availableFor: this.availableFor('ORCA_MODULE')
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["title", "orderMailToLink", "moreInfoMailToLink", "availableFor"]),
            _createVNode(_component_option_pack_card, {
              title: this.productDescription('ORDER_SMS_COMMUNICATION'),
              orderMailToLink: this.orderMailToLink('ORDER_SMS_COMMUNICATION'),
              moreInfoMailToLink: this.moreInfoMailToLink('ORDER_SMS_COMMUNICATION'),
              licensePrice: "€ 0,12",
              licensePriceSuffix: " per SMS *",
              priceInfo: "* Deze prijs wordt na ieder licentiejaar berekend op het werkelijk verbruik van het voorbije licentiejaar.",
              availableFor: this.availableFor('ORDER_SMS_COMMUNICATION')
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["title", "orderMailToLink", "moreInfoMailToLink", "availableFor"]),
            _createVNode(_component_option_pack_card, {
              title: this.productDescription('MULTI_PHARMACY_PACK'),
              moreInfoMailToLink: this.moreInfoMailToLink('MULTI_PHARMACY_PACK'),
              availableFor: this.availableFor('MULTI_PHARMACY_PACK')
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["title", "moreInfoMailToLink", "availableFor"]),
            _createVNode(_component_option_pack_card, {
              title: this.productDescription('PHARMACY_GROUP_MEMBER_PACK'),
              moreInfoMailToLink: this.moreInfoMailToLink('PHARMACY_GROUP_MEMBER_PACK'),
              availableFor: this.availableFor('PHARMACY_GROUP_MEMBER_PACK')
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["title", "moreInfoMailToLink", "availableFor"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}